<div class="delivery-modal">
  <h2 class="label-title">{{this.modalTitle}}</h2>
  <h5 class="label-text">{{this.modalText}}</h5>

  <ion-button expand="block"
              color="success"
              (click)="onOkButtonClick()"
              class="button">
    {{this.modalOkButton}}
  </ion-button>

  <ion-button expand="block"
              color="medium"
              (click)="onCancelButtonClick()"
              class="button">
    Cancel
  </ion-button>
</div>
